module.exports = __webpack_public_path__ + "img/pg3_data.b98a8ac7.png";